import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useMergeRefs, useOverflow } from '../hooks';
import { Tooltip } from '../tooltip';
import { Typography } from '.';
export const TypographyWithTooltip = React.forwardRef((props, ref) => {
    const { tooltipProps, ...typographyProps } = props;
    const innerRef = useMergeRefs(ref);
    const { textOverflow } = useOverflow(innerRef, props.children);
    const nowrap = !typographyProps.lineClamp;
    // TODO: tooltip is not working with lineClamp 😔
    // @see packages/ml-rubiks-styleguide/src/widget/list.tsx#L300 for a possible complicated solution
    return (_jsx(Tooltip, { title: props.children, bypass: !textOverflow, ...tooltipProps, children: _jsx(Typography, { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: nowrap ? 'nowrap' : undefined, minWidth: 0, ...typographyProps, ref: innerRef }) }));
});
